import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import { useSelector } from 'react-redux';

import { TextArea } from 'components/Form/Fields';
import oWnApi from 'utils/WnApi';
import PageLayout from 'components/Layout/PageLayout';
import { SubmitButton } from 'components/Form/Buttons';
import usePageTitle from 'utils/hooks/usePageTitle';
import { fnSendFormSubmitEventToGoogleTagManager } from 'utils/common';
import deaconNotWorking from 'components/NotFound/deacon404.png';
import CopyToClipboardButton from 'components/Buttons/CopyToClipboardButton';
import contactUsSchema from './schemas';
import BestEmailToContactYouField from './BestEmailToContactYouField';

const oInitialValues = {
  email: '',
  comments: '',
};

const sFormName = 'Contact Us';
const sFormId = 'contact-us-form';

const ContactUs = () => {
  const oProfileData = useSelector((state) => state.Profile || {});

  const [uiPhase, setUiPhase] = useState('default'); // 'default', 'success', or 'error'
  const [comments, setComments] = useState('');

  usePageTitle('Contact Us');

  const handleSubmit = async (oFormData) => {
    setComments(oFormData.comments);

    fnSendFormSubmitEventToGoogleTagManager(sFormName, sFormId);
    const oRequestPayload = {
      firstname: (oProfileData.BIOGRAPHICAL || {}).FIRSTNAME || '',
      lastname: (oProfileData.BIOGRAPHICAL || {}).LASTNAME || '',
      email: oFormData.email,
      comments: oFormData.comments,
      contactmethod: 'email',
    };
    try {
      const oResponse = await oWnApi.post('contact_us', oRequestPayload);
      if (oResponse.status === 200) {
        setUiPhase('success');
      } else {
        throw new Error(
          `Failed to submit contact us request. ${oResponse.status}: ${oResponse.statusText}`
        );
      }
    } catch (error) {
      setUiPhase('error');
    }
  };

  return (
    <PageLayout sTitle='Contact Us'>
      {uiPhase === 'default' && (
        <div className='contactUs__formWrapper'>
          <h1>Contact Us</h1>
          <Formik
            onSubmit={handleSubmit}
            initialValues={oInitialValues}
            validateOnBlur
            validationSchema={contactUsSchema}
          >
            {() => (
              <Form name={sFormName} id={sFormId}>
                <h2 className='helpHeading'>
                  Having trouble? We&apos;re here to help.
                </h2>
                <p>
                  Please share a bit more information here, and we&apos;ll reach
                  out to you soon!
                </p>
                <div className='authHelpForm__fieldsWrapper'>
                  <TextArea sId='comments' sName='comments' sLabel='Comments' />
                  <BestEmailToContactYouField />
                </div>
                <SubmitButton>Send</SubmitButton>
              </Form>
            )}
          </Formik>
        </div>
      )}
      {uiPhase === 'success' && (
        <>
          <h1 className=''>Request Successfully Sent</h1>
          <p className='t-paragraph--large'>
            Someone from Wake Forest will be in contact with you soon.
          </p>
        </>
      )}
      {uiPhase === 'error' && (
        <>
          <img
            src={deaconNotWorking}
            alt='Deacon not working'
            className='contactUs__errorImg'
          />
          <h1>Something went wrong</h1>
          <p className='t-paragraph--large'>
            Please send us an email at{' '}
            <a href='mailto:wknthelp@wfu.edu' className='t-paragraph--large'>
              wknthelp@wfu.edu
            </a>
            , and we will get back to you as soon as possible.
          </p>
          {comments && (
            <>
              <p>
                For your convenience, here&apos;s what you wrote in the contact
                us form:
              </p>
              <div className='contactUs__errorCommentsWrapper'>
                <p className='t-paragraph--small'>{comments}</p>
                <CopyToClipboardButton textToCopy={comments} />
              </div>
            </>
          )}
        </>
      )}
    </PageLayout>
  );
};

export default ContactUs;
